import { render, staticRenderFns } from "./examPlanInfo3.vue?vue&type=template&id=63e04534&scoped=true"
import script from "./examPlanInfo3.vue?vue&type=script&lang=js"
export * from "./examPlanInfo3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e04534",
  null
  
)

export default component.exports